import { styles, variants, LabelTheme } from '../LabelStyles.css';
import { baseTheme } from './LabelBaseTheme.css';
import { multiVariantStyles } from './LabelVariants.css';

/*******************
 * Component Theme
 *******************/

const LabelStableTheme: LabelTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { LabelStableTheme };
